import { ChainId, Hardhat } from "@usedapp/core";

export const buyTruthAddresses = {
  [ChainId.Mainnet]: '0xFB8A515477dC93bf91F4d78B63ca7632E39cD235',
  [ChainId.Goerli]: '0x604568C8864059EC5dF5b0F2EB8F8654C0C263b5',
  [Hardhat.chainId]: '0x5fbdb2315678afecb367f032d93f642f64180aa3'
}

export const endpoints = {
  //api: 'http://localhost:3000/dapp/api',
  api: 'https://buytruth.cc/dapp/api',
  chainId: ChainId.Mainnet,
  rpcUrl: 'https://omniscient-greatest-grass.quiknode.pro/09e42f3363811506531e8d5e8bdf6215e2e61b6d'
  //chainId: ChainId.Goerli,
  //rpcUrl: 'https://goerli.infura.io/v3/893773b596df4198bcf912305588d650'
}

//1: 0x604568C8864059EC5dF5b0F2EB8F8654C0C263b5 // V3 Pool - 40 ETH - Test Launched
//2: 0x23E868910F09Ee35573740CfDC9661835182652A // V3 Pool - 5 ETH - BuyBot Testing

// TEST LAUNCH BLOCK DELAY: 72000 (10 days)
// ANTI WHALE DELAY: 21600 (~72 hours)

// ===== LEDGER ADDRESSES =======
// Dev Fund: 0xccD117d210d7f73bD6Ae363c22B9921002Cb2E67
// Charity: 0xCA2Bfb05E7fa10946EA4344031344E128d018cCf
// Deployer: 0xBC99cE48C919E081Aa3a9F0fe9c8f6AD1a63B39E

// Uniswap Addresses: https://docs.uniswap.org/contracts/v3/reference/deployments


// ---- Playbook ----
// Add total supply to Uniswap V3 LP
// Whitelist LP: pool that holds the balance
// Send deployer's remaining balance to the pool (dust)
// Update launch delay if needed
// Renounce ownership
// Launch!!!
// Lock liquidity with UNCX

// NOTE: Cannot withdraw from LP until anti-whale time has passsed
